import $ from 'jquery'
import _ from 'lodash'
import FacebookService from 'services/facebook_service'
import { isVisible }  from 'utils/viewport'
import 'application/shared/facebook_comment_observer'
import 'application/shared/create_wish_using_explanation_and_lead_form'
import amplitude from 'application/trackable/amplitude'

import { initMultipleSlider } from 'application/shared/sliders'

_require [
  'jquery/select2',
  'jquery/select2v3',
  'jquery_visible',
], ->
  initMultipleSlider()

  hasShift = $('.js-grades-with-shift').length
  $gradesFormCompetitionSelect = $('.js-grades-form__competition-select')
  $gradesFormCompetitionSelect.select2
    theme: $gradesFormCompetitionSelect.data('theme')

  $('#interest_email, .search.quick-form .email-field-js').on 'change, focus, blur', ->
    if $(this).hasClass('error')
      $(this).siblings('.email-icon').css('background-color', $(this).css('background-color'))
      $(this).closest('form').find('input[type="submit"]').prop('disabled', true)
    else
      $(this).siblings('.email-icon').removeAttr( 'style' )
      $(this).closest('form').find('input[type="submit"]').prop('disabled', false)

  moveToHash = ->
    target = $(location.hash)
    if target.length
      $('html, body').animate
        scrollTop: target.offset().top - 25

  # Sets active menu item with hash
  setActiveMenu = ->
    $('.dropdown').find('.active').removeClass('active')
    link = $("a[href='#{location.pathname}#{location.hash}']")
    parent = link.parent()
    parent.addClass('active')

  $(window).on 'hashchange', () ->
    setActiveMenu()

  $(window).scroll()

  setPaginationBehavior = ->
    financing = $('.financiamento-estudantil')
    nav = financing.find('nav')

    if nav.length
      prev = nav.find('.prev')
      next = nav.find('.next')

      maxPages = nav.find('a[data-page]').length

      activate = (page) ->
        financing.find('.row[data-page]').addClass('hide')
        financing.find(".row[data-page=#{page}]").removeClass('hide')

        nav.find('a[data-page]').removeClass('active')
        nav.find("a[data-page=#{page}]").addClass('active')

        if page is 1
          prev.find('img.disabled').removeClass('hide')
          prev.find('img.enabled').addClass('hide')
        else
          prev.find('img.enabled').removeClass('hide')
          prev.find('img.disabled').addClass('hide')

        if page is maxPages
          next.find('img.disabled').removeClass('hide')
          next.find('img.enabled').addClass('hide')
        else
          next.find('img.enabled').removeClass('hide')
          next.find('img.disabled').addClass('hide')

        $(window).scrollTop(0)

      nav.find('a[data-page]').click () ->
        activate(parseInt($(@).attr('data-page')))

      prev.click () ->
        if (p = parseInt(nav.find('a[data-page].active').attr('data-page')) - 1) > 0
          activate(p)

      next.click () ->
        if (p = parseInt(nav.find('a[data-page].active').attr('data-page')) + 1) <= maxPages
          activate(p)

  setActiveMenu()

  setPaginationBehavior()

  setTimeout moveToHash, 2000

  $('#course_clean_name, #city_state').select2V3
    formatNoMatches: (term)->
      return "Nenhum resultado contendo '#{term}' encontrado."
    formatSearching: ->
      return "Buscando resultados..."
    formatInputTooShort: (term, minLength)->
      return "Digite pelo menos #{minLength} caracteres."
    formatLoadMore: (page)->
      return "Carregando mais resultados..."
    containerCssClass: 'qb-s2v3'
    dropdownCssClass: 'qb-s2v3'
    minimumInputLength: 3

  enem_subjects = () ->
    return ['#languages', '#mathematic', '#human_sciences', '#nature', '#redaction']

  setSubjectsDisabled = (value) ->
    for subject in enem_subjects()
      $(subject).prop('disabled', value)

  $('.js-financial-aid__enem-grade-switch').on 'click', (e)->
    $('.financial-aid__enem-detailed-grades').toggle()
    $grade = $('#grade')
    $grade.prop('disabled', !$grade.prop('disabled'))

    if $grade.prop('disabled')
      $grade.val(null)
      setSubjectsDisabled(false)
      $(this).text('Não sei minha nota média do Enem')
    else
      info = getUserInfo()
      value = if info then info.grade else ''
      $grade.val(value)
      setSubjectsDisabled(true)
      $(this).text('Calcular a minha nota média do Enem')

  check_email_format = (field) ->
    regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return !regex.test($(field).val())

  check_input_rate_interval = (field) ->
    value = $(field).val()
    return (!value || +value > 1000 || +value < 0)

  check_input_field = (field) ->
    return !$(field).val()

  mountObjectField = (id, fieldName, check) ->
    return { id, fieldName, check }

  mountEnemFieldsToValidate = () ->
    return enem_subjects().map (subject) ->
      mountObjectField(subject, subject, check_input_rate_interval)

  mountFieldsToValidate = () ->
    fields = [
      mountObjectField('#email_lead', '#email_lead', check_email_format),
      mountObjectField('#s2id_course_clean_name', '#course_clean_name', check_input_field),
      mountObjectField('#s2id_city_state', '#city_state', check_input_field),
    ]

    gradeFields = if $('#grade').prop('disabled')
    then mountEnemFieldsToValidate()
    else [ mountObjectField('#grade', '#grade', check_input_rate_interval) ]

    return fields.concat(gradeFields)

  validateFieldsOnsubmit = (fields) ->
    valid = true

    for field in fields
      if field.check(field.fieldName)
        markInvalid(field.id)
        valid = false

    return valid

  enemAverage = () ->
    average = 0
    $grade = $('#grade')
    enem_subjects = enem_subjects()

    for subject in enem_subjects
      $element = $(subject)
      average += +$element.val()
      $element.prop('disabled', true)

    average /= enem_subjects.length
    $grade.val(average.toFixed(2))
    $grade.prop('disabled', false)

  getUserInfo = () ->
    return JSON.parse(localStorage.getItem('qb-financial-aid'))

  setUserInformation = () ->
    info = getUserInfo()
    if info
      $('#email_lead').val(info.email)
      $('#city_state').val(info.city_state).trigger('change')
      $('#course_clean_name').val(info.course_clean_name).trigger('change')
      $('#grade').val(info.grade)

  $(window).load ->
    setUserInformation()

  saveUserInformations = () ->
    info = JSON.stringify({
      email: $('#email_lead').val(),
      city_state: $('#city_state').val(),
      course_clean_name: $('#course_clean_name').val(),
      grade: $('#grade').val(),
    })

    localStorage.setItem('qb-financial-aid', info)

  $('#sim-submit').on 'click touchstart', (e)->
    e.preventDefault()
    fieldsToValidate = mountFieldsToValidate()
    valid = validateFieldsOnsubmit(fieldsToValidate)

    if valid
      $grade = $('#grade')

      if $grade.prop('disabled')
        enemAverage()

      if $('#email_lead').val()
        dataToPush =
          event             : "FinancialAidLeadSubmit"
          email             : $("#email_lead").val()
          subscription_type : ["programas-do-governo-simulador-enem"]
          subscription_data : [
            nota_enem : $grade.val()
            city      : $("#city_state").val()
            course    : $("#course_clean_name").val()
            slug      : _.kebabCase($("#course_clean_name").val())
          ]

        dataLayer.push dataToPush

      saveUserInformations()
      $(this).closest('form').trigger('submit')

  $('.js-remove-error-class').on 'change', (e) ->
    element = $(e.currentTarget)
    elementId = element.attr('id')

    if(element.is('select'))
      removeErrorClass('#s2id_' + elementId)
    else
      removeErrorClass('#' + elementId)

  markInvalid = (eltName)->
    s2container = $(eltName)
    s2container.addClass('error')
    s2container.find('.select2-choice').addClass('error')
    s2container.closest('.row').addClass('error')

  removeErrorClass = (eltName) ->
    s2container = $(eltName)
    s2container.removeClass('error')
    s2container.find('.select2-choice').removeClass('error')
    s2container.closest('.row').removeClass('error')

  getColumn = () ->
    columns = [
      {
          data: "name"
          render: (data, type, full, meta) ->
            result = data
            if full['url']
              result = '<a href="' + full["url"] + '">' + full["name"] + '</a>
                        <div class="details visible-xs">
                          <span class="block"><strong>Campus: </strong>' + full["campus"] + '</span>
                          <span><strong>Turno: </strong>' + full["shift"] + '</span> '
              if hasCompetitionKind
                result += '<span><strong>Tipo de disputa: </strong>' + full["cleanCompetitionKind"] + '</span>'

              result += ' <span><strong>Cidade: </strong>' + full["city"] + '</span>
                          <span><strong>Estado: </strong>' + full["state"] + '</span>
                          <span><strong>Distância: </strong>' + full["dist"] + ' Km</span>
                        </div>'
            else
              result = result.replace('Distância: </strong>-', ('Distância: </strong>' + full["dist"] + ' Km'))
            return result
        }
        {
          data: "campus"
          sClass: "hidden-xs"
        }
    ]

    if hasShift
      columns.push {
        data: "shift"
        sClass: "hidden-xs"
      }

    columns.push {
      data: "grade"
      sClass: "grade"
    }

    if hasCompetitionKind
      columns.push {
        data: "cleanCompetitionKind"
        sClass: "hidden-xs"
      }

    columns.push [
      {
        data: "city"
        sClass: "hidden-xs"
      }
      {
        data: "state"
        sClass: "hidden-xs"
      }
      {
        data: "dist"
        sClass: "hidden-xs"
      }
    ]...

    return columns

  getColumnOrder = () ->
    if hasShift
      order_column = [3, "asc"]
    else
      order_column = [2, "asc"]
    return order_column

  getDistColumn = () ->
    distColumn = 5
    distColumn += 1 if hasShift
    distColumn += 1 if hasCompetitionKind
    return distColumn

  sortable_size = (data, type, full, meta) ->
    if type == 'display' && data != '-'
      return data + " Km"
    else
      return data

  $('#fb-share').click (ev) ->
    FacebookService.loadSdk().then((FB) ->
      FB.ui {
        method: 'share'
        hashtag: '#enem'
        href: document.location.origin + "/programas-do-governo"
        quote: $('#share-grades').text()
      }, (response) ->
    )

  $('#notaQueroEnemKnowMore, #notaQueroEnemQueroBolsaKnowMore').on 'click', (e) ->
    amplitude.track('ClickedOnDiscoveryNotaQuero', {
      origin: 'enem',
    })

  $('#notaQueroEnemDiscovery, #notaQueroEnemQueroBolsaDiscovery').on 'click', (e) ->
    amplitude.track('ClickedOnKnowMoreAboutNotaQuero', {
      origin: 'enem',
    })

  $('#notaQueroProuniKnowMore').on 'click', (e) ->
    amplitude.track('ClickedOnDiscoveryNotaQuero', {
      origin: 'prouni',
    })

  $('#notaQueroProuniDiscovery').on 'click', (e) ->
    amplitude.track('ClickedOnKnowMoreAboutNotaQuero', {
      origin: 'prouni',
    })

  if $('.js-grades-university').length || $('.js-grades-course').length
    hasCompetitionKind = program_gov != 'fies'
    column = getColumn()
    order_column = getColumnOrder()
  else
    column = [
      { data: "name" }
      { data: "university" }
      { data: "grade" }
      { data: "city" }
      { data: "state" }
    ]

  pageLength = if $('body.mobile').length then 5 else 20

  univTable = $('#sisu-table')

  _require ['jquery/dataTables'], ->
    univTable = $('#sisu-table').DataTable
      fixedHeader: false
      responsive: false
      deferRender: true
      lengthChange: false
      pageLength: pageLength
      processing: true
      searching: false
      info: false
      order: order_column
      columns: column
      columnDefs: [
        { targets: getDistColumn(), render: sortable_size }
      ]
      language:
        sEmptyTable: "Nenhum registro encontrado"
        sLoadingRecords: "Carregando..."
        sProcessing: "Processando..."
        sZeroRecords: "Nenhum registro encontrado"
        oPaginate:
          sNext: 'Próximo <i class="fa fa-angle-right"></i>'
          sPrevious: '<i class="fa fa-angle-left"></i> Anterior'
      initComplete: ->
        updateDistances(this.DataTable().rows().data(), this.DataTable())
    $(univTable.rows().nodes()).addClass("pgc-table__row")
    $(univTable.cells().nodes()).addClass("pgc-table__item pgc-table__item--body pgc-table__item--light")

    univTable.on 'page.dt order.dt', ->
      setTimeout ->
        $(univTable.rows().nodes()).addClass("pgc-table__row")
        $(univTable.cells().nodes()).addClass("pgc-table__item pgc-table__item--body pgc-table__item--light")
      , 100
    return

  updateDistances = (data, table) ->
    if $.fn.DataTable.isDataTable('#sisu-table')
      newData = []
      $.each data, (index, row) ->
        cityState = row.city + ' - ' + row.state
        dist = distances[cityState]
        if dist != undefined
          row.dist = Math.round(dist / 1000)
        else
          row.dist = '-'
        newData.push row
        return
      table.clear().rows.add(newData).draw()
      window.allData = table.rows().data()
      return
    return

  updateGradesInfoCards = (hashData) ->
    for selector in _.keys(hashData)
      $('.'+selector).text(hashData[selector])

  showOrHideGradesInfoCards = () ->
    $gradesInfoContainer = $('.js-grades-info-container')
    $gradesInfoContainer.hide('fast')
    selectorsToCheck = ['.js-grade-info-card__1st-value',
                     '.js-grade-info-card__2nd-value',
                     '.js-grade-info-card__3rd-value']
    show = false
    for selectorToCheck in selectorsToCheck
      if $(selectorToCheck).text().trim() != '---'
        show = true

    if show
      $gradesInfoContainer.show('fast')

  _submitForm = ->
    toggleLoading = -> $('#loading').toggleClass('hidden')

    if (window.QB && window.QB.skipFinancialAidSpinner)
      window.QB.skipFinancialAidSpinner = false
      toggleLoading = -> {}

    toggleLoading()

    # Wait other ajaxs to finish
    $(document).ajaxStop( ->
      $(this).unbind('ajaxStop')
      setTimeout ->
        $.ajax
          url: $('.js-grades-form').prop('action')
          data: $('.js-grades-form').serialize()
          success: (data) ->
            gradesInfoData = data.shift()
            updateGradesInfoCards(gradesInfoData)
            showOrHideGradesInfoCards()
            window.distances = JSON.parse(gradesInfoData['city_distances']["all_distances"])
            window.state = gradesInfoData['city_distances']["state"]
            updateDistances(data, univTable)
            $('.visible-xs .js-filter-state-button').text("Apenas " + window.state)
            $('.hidden-xs .js-filter-state-button').text("Notas de corte apenas de " + window.state)
            $('.js-filter-brasil-button').addClass('button--active')
            $('.js-filter-state-button').removeClass('button--active')
            toggleLoading()
          error: ->
            toggleLoading()
      , 2000
    )
    return

  $('.js-filter-state-button').click ->
    if $.fn.DataTable.isDataTable('#sisu-table')
      $('.js-filter-state-button').addClass('button--active')
      $('.js-filter-brasil-button').removeClass('button--active')
      newData = []
      $.each univTable.rows().data(), (index, row) ->
        if row.state == window.state
          newData.push row
        return
      univTable.clear().rows.add(newData).draw()

  $('.js-filter-brasil-button').click ->
    if $.fn.DataTable.isDataTable('#sisu-table')
      $('.js-filter-brasil-button').addClass('button--active')
      $('.js-filter-state-button').removeClass('button--active')
      univTable.clear().rows.add(window.allData).draw()

  $('.js-grades-form #interest_city, #competition_kind').on 'select2:select', ->
    _submitForm()

  $('#dropdown-universities, #dropdown-courses').select2
    theme: 'normal-l'

  $('#dropdown-universities, #dropdown-courses').change ->
    location.href = $(this).val()

  $('.js-grades-form__filter-area').show('fast')
  showOrHideGradesInfoCards()
  return

if $('[name="interest[course]"]').length > 0
  _require ['canonical_selector_v4'], ->
    $('.js-canonical-selector').prop('disabled', false)
    canonicalSelect = new QB.CanonicalSelectorV4()
    canonicalSelect.init('.js-canonical-selector', { idVal: 1 })

_require ['metrics'], ->
  url = window.location.pathname
  path = url.split('/')
  content_type = 'Program Descriptions'
  title = document.title.split(' | ')[0]
  program = path[1]

  if path[2] == 'notas-de-corte'
    title = document.title.split(' - ')[0]

  if path.length > 3
    content_type = 'Minimum Scores'
    if path[3] == 'faculdades'
      uni = path[4]
    else
      course = path[4]

  props = { content_type: content_type, program: program, title: title, university: uni, course: course }

  trackable.eventTracker.track(Metrics.Events.ViewedGovernmentContent, props)

  leadForm = document.querySelector('.js-explanation-n-lead-form')

  if leadForm
    $('.js-explanation-n-lead-form__submit').on 'click', ->
      trackable.eventTracker.track(Metrics.Events.ClickedLeadSection, props)
